interface Props {
    icon: string;
    title: string;
}


const Title = ({title, icon}: Props) => {
    return (
        <div className="display-flex align-items-center gap-20">
            <div className="border border-color-primary border-width-3 border-style-solid width-50 height-50 display-flex justify-content-center align-items-center">
                <span
                    className={`${icon} text-size-h1 text-color-primary`}
                />
            </div>
            <p className="text-size-h2 text-bold">
                {title}
            </p>
        </div>
    )
}

export default Title;